import { sendErrorMetric } from "@expert/cloudwatch-metrics";

const SALES_TOOLS_COMPONENT = "sales-tools";

/**
 * Sales-tools-owned wrapper around the shared `sendErrorMetric`. Tags every call with
 * `component: "sales-tools"` so downstream alert rules can scope to this package by label
 * instead of maintaining a hand-kept errorType allowlist.
 */
export async function sendSalesErrorMetric(errorType: string, additionalDimensions?: Record<string, string>) {
    return await sendErrorMetric(errorType, { ...additionalDimensions, component: SALES_TOOLS_COMPONENT });
}
